<template>
  <el-container class="ProductionContractForm">
    <el-main class="p-0 pb-default">
      <el-form class="form-label-80" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="거래처명" prop="customer_name">
              <el-input
                v-model="data.customer_name"
                class="readonly"
                readonly
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="납기일" prop="delivery_date">
              <ADatePicker
                v-model="data.delivery_date"
                class="readonly"
                readonly
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs
        ref="tabs"
        v-model="activeTab"
        type="card"
        @tab-click="handelTabClick"
      >
        <el-tab-pane
          v-for="(item, index) in items"
          v-bind:key="item.contract_detail_id"
          :label="item.product_name"
          :name="index.toString()"
          :disabled="item.status_flag !== '0'"
        >
          <el-form class="form-label-80" label-width="80px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="품목" prop="product_name">
                  <el-input
                    v-model="item.product_name"
                    class="readonly"
                    readonly
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="규격" prop="size">
                  <el-input v-model="item.size" class="readonly" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="생산번호" prop="code">
                  <el-input v-model="item.code" class="readonly" readonly />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="사양" prop="specification">
                  <el-input v-model="item.specification" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="계획일" prop="plan_date">
                  <ADatePicker v-model="item.plan_date" :clearable="false" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="계획수량" prop="plan_date">
                  <el-input
                    v-model="item.plan_amount"
                    class="readonly"
                    readonly
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="비고" prop="desc">
                  <el-input v-model="item.desc" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div
            class="bomtree-container flex of-auto"
            style="max-height: 400px;"
          >
            <div class="flex-fixed" style="width: 500px;">
              <ABomTree
                ref="tree"
                :id="item.product_id"
                :size="item.size"
                :specifications="item.specifications"
                :data="item.detail"
                :editable="true"
                selectionMode
                @completed="handleBomTreeCompleted(item, $event)"
              />
            </div>
            <div class="flex-auto of-auto">
              <ABomTable :production="production" :material="material" />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['F4']"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ $t("button.register") }}(F4)</el-button
      >
      <el-button class="close-button" @click="handleCloseDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";
import { production_process } from "@/common/mixins/production_process";

export default {
  name: "ProductionContractForm",
  mixins: [form, production_process],
  data() {
    return {
      title: "생산지시",
      activeTab: "0",
      productionItems: [],
      items: [],
      currentIndex: 0,
      // 객체가 깊어지는 경우 변경이 감지되지 않아서 변수로 선언하여 사용
      production: [],
      material: [],
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.loadData();
  },
  computed: {
    ...mapGetters(["table_product"]),
    currentItem() {
      return this.items[this.currentIndex];
    },
  },
  methods: {
    loadData() {
      this.api.listProductionContract(this.data).then((res) => {
        this.productionItems = res.data;
        this.loadProductionItems();
      });
    },
    loadProductionItems() {
      /**
       * 현재 등록된 생산정보를 가져와서 먼저 보여주고
       * 그 다음 수주 정보를 불러온다.
       */

      this.items = Object.assign([], this.productionItems);
      this.data.details.forEach((d) => {
        // 이미 등록된 것이 있으면 skip
        let item = this.items.find((item) => item.contract_detail_id === d.id);
        if (item) {
          return true;
        }
        let product = this.table_product.find((p) => p.id === d.product_id);
        if (!product) {
          return true;
        }
        if (product.bom_flag !== "Y") {
          return true;
        }
        if (!d.specification) {
          //사양이 설정되지 않으면 기계
          this.items.push({
            id: 0,
            code: "",
            contract_id: d.contract_id,
            contract_detail_id: d.id,
            plan_date: this.util.getDate(),
            delivery_date: this.util.getDate(1),
            customer_id: this.data.customer_id,
            customer_name: this.data.customer_name,
            plan_amount: d.amount,
            product_id: d.product_id,
            product_name: d.product_name,
            seq: d.seq,
            size: d.size,
            status_flag: "0",
            specifications: [],
            detail: {
              bom: [],
              production: [],
              material: [],
            },
          });
        } else {
          //사양이 등록되었다면 상위 품목에 사양 정보를 넣는다.
          d.specification.forEach((seq) => {
            let parent = this.items.find((item) => item.seq === seq);
            if (!parent) {
              return true;
            }
            parent.specifications.push({
              product_id: d.product_id,
              product_name: d.product_name,
              plan_amount: d.per_amount,
            });
            if (!parent.specification) {
              parent.specification = "";
            } else {
              parent.specification += ",";
            }
            parent.specification +=
              d.product_name + ": " + d.per_amount + product.unit_name;
          });
        }
      });
    },
    doRegister() {
      this.processProduction(
        "생산 등록 중입니다.",
        () => this.api.registerProduction(this.items),
        {
          success: () => {
            this.util.notify_success(this, this.title, "등록되었습니다.");
            this.$emit("completed", true);
          },
        }
      );
    },
    handelTabClick(item) {
      this.currentIndex = Number.parseInt(item.name);
      this.production = Object.assign([], this.currentItem.detail.production);
      this.material = Object.assign([], this.currentItem.detail.material);
    },
    handleBomTreeCompleted(item, result) {
      // 생산 대기중이 아니리면 업데이트 하지 않는다.
      if (item.status_flag !== "0") {
        return;
      }
      item.detail = result;
      if (this.currentItem.contract_detail_id !== item.contract_detail_id) {
        return;
      }
      this.production = Object.assign([], result.production);
      this.material = Object.assign([], result.material);
    },
    handleClickRegister() {
      let isValid = true;
      this.items.forEach((item) => {
        if (!isValid) {
          return false;
        }
        if (!item.plan_date) {
          this.util.notify_warning(
            this,
            this.title,
            item.product_name + " 계획일을 선택해 주세요."
          );
          isValid = false;
        }
        if (!isValid) {
          return false;
        }
        if (item.detail.bom.length < 1) {
          this.util.notify_warning(
            this,
            this.title,
            item.product_name + " 생산 계획을 선택해 주세요."
          );
          isValid = false;
        }
      });
      if (!isValid) {
        return;
      }
      this.doRegister();
    },
    handleCloseDialog() {
      this.$emit("completed");
    },
  },
};
</script>

<style lang="scss">
.ProductionMultiForm {
  .bomtree-container {
    max-height: 400px;
    overflow: auto;
  }
}
</style>
